import React, { useEffect, useState } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FPerfilesStyle } from "./styles";
import { useFormik } from "formik";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import {
  altaRolAction,
  actulizaRolAction,
  obtnerRolesByIdAction
} from "../../../ducks/rolDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "../../../global/BackDrop";
import ModalBase from "../../../global/ModalBase";
import * as yup from "yup";
const validationSchema = yup.object({
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
});

const FRoles = (props) => {
  const {
    open = true,
    setOpen = () => {},
    rowData = {},
    editar = false,
    setEditar = () => {},
  } = props;

  const InitalValues = {
    nombre: "",
  };

  const dispatch = useDispatch();
  const classes = FPerfilesStyle();
  const [isLoad, setIsLoad] = useState(false);

  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      (editar) ? onUpdate(values)  : onSave(values)
    },
  });

  const onUpdate = (values) =>{
    setIsLoad(true);
    let payload = {
      Name: values.nombre,
    };
    dispatch(actulizaRolAction(rowData.Id, payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }
  const onSave = (values) =>{
    setIsLoad(true);
    let payload = {
      Name: values.nombre,
    };
    dispatch(altaRolAction(payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }
  useEffect(() => {
    const buscarById = () => {
      setIsLoad(true);
      dispatch(obtnerRolesByIdAction(rowData.Id)).then(
        (Response) => {
          formik.setFieldValue("nombre", Response.Name);
          setIsLoad(false);
        }
      );
    };
    if (editar) buscarById();
    return () => {
      LimpiarForm();
    };
  }, [editar, rowData.Id, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const LimpiarForm = () => {
    formik.resetForm(InitalValues);
  };
  const handleClose = () => {
    setOpen(!open);
    setEditar(false);
    LimpiarForm();
  };
  
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={editar ? "Actuliza rol" : "Nuevo rol"}
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <TextField
              required
              id="input-Nombre"
              label="Nombre"
              type="text"
              variant="outlined"
              name="nombre"
              value={formik.values.nombre}
              onChange={formik.handleChange}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={formik.touched.nombre && formik.errors.nombre}
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              {editar ? "Actulizar" : "Guardar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </form>
    </ModalBase>
  );
};
export default FRoles;
